export const DEFAULT_LOCALE = 'en';
// If you're adding locale see webpack.config.js MomentLocalesPlugin
export const APP_LOCALES = [
    'en-gb',
    'en',
    'en-au',
    'en-ie',
    'en-hk',
    'en-sg',
    'ar',
    'bg',
    'cs',
    'de',
    'de-ch',
    'es',
    'fi',
    'fr',
    'fr-ca',
    'fr-ch',
    'el',
    'he',
    'hr',
    'it',
    'it-ch',
    'nl',
    'pl',
    'pt',
    'pt-br',
    'ro',
    'sl',
    'sr',
    'sv',
    'th',
    'tr',
    'zh-hk'
];
export const APP_LOCALE_LANGUAGES_MAP = {
    'zh-hk': 'zh-Hant'
};
